import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Washline',
    description: 'Run your car wash from your phone. Register vehicles in seconds, assign staff, track every wash live and bill on the spot.',
    placeholder: 'Car wash operations, from vehicle entry to payment.',
    url: getOrigin()
}
